<template>
  <div id="hresh1x">
    <hrms-search-box-table v-show="indexDisp"
            v-model="searchIndex"
            :data="index"
            :nowLang="app.nowLang"
            :unLoadBool="true"
            :columns="columns[app.nowLang].index"
            :receivedStore="receivedHresh1xIndex"
            :maxRowspan="maxRowspan.index"
            searchBoxAlias="hresh1x"
            :csvExportDisp="false"
            :detailEvent="detailEvent" />

    <detail  v-show="detailDisp"
            :labels="labels[app.nowLang]"
            :labelsButton="app.button[app.nowLang]"
            :indexSelected="indexSelected"
            :codempid="codempid"
            :descCodempid="app.currentUser.username[app.nowLang]"
            :detail="detail"
            :nowLang="app.nowLang"
            :toggle="toggle"
            :tab3Table="columns[app.nowLang].detailTab3"   />


  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'
import * as types from 'store/modules/hresh1x/mutation-types'
import detail from 'components/hresh1x/detail'
import moment from 'moment'

export default {
  name: 'hresh1x',
  data () {
    return {
      app: this.$parent.$parent.$parent,
      searchIndex: {
        codempid: '',
        dtestrt: '01/01/' + moment().format('YYYY'),
        dteend: moment().format('DD/MM/YYYY')
      },
      searchParams: {
        'p_codempid': ''
      }
    }
  },
  created () {
    let currPath = this.$route.fullPath.split('/')[1]
    let params = typeof (currPath.split('?')[1]) !== 'undefined' ? currPath.split('?')[1] : ''
    let arrParam = params.match(/codempidq=([0-9a-zA-Z]+)/)
    if (arrParam !== null) {
      this.searchIndex.codempid = arrParam[1] !== 'null' ? arrParam[1] : this.app.currentUser.p_codempid
    } else {
      this.searchIndex.codempid = this.app.currentUser.p_codempid
    }
    this.receivedHresh1xColumnsLabels()
  },
  computed: {
    codempid () {
      let currentUser = this.app.currentUser
      return currentUser.p_codempid
    },
    ...mapGetters({
      indexDisp: types.GET_HRESH1X_INDEX_DISP,
      detailDisp: types.GET_HRESH1X_DETAIL_DISP,
      maxRowspan: types.GET_HRESH1X_MAX_ROWSPAN,
      columns: types.GET_HRESH1X_COLUMNS,
      labels: types.GET_HRESH1X_LABELS,
      index: types.GET_HRESH1X_INDEX,
      indexSelected: types.GET_HRESH1X_INDEX_SELECTED,
      detail: types.GET_HRESH1X_DETAIL
    })
  },
  methods: {
    detailEvent (param) {
      this.setIndexSelected(param)
      this.receivedHresh1xDetail(this.indexSelected)
      this.toggle('detail')
    },
    ...mapMutations({
      setIndexSelected: types.SET_HRESH1X_INDEX_SELECTED
    }),
    ...mapActions({
      toggle: types.TOGGLE_HRESH1X_PAGE,
      receivedHresh1xColumnsLabels: types.RECEIVED_HRESH1X_COLUMNS_LABELS,
      receivedHresh1xIndex: types.RECEIVED_HRESH1X_INDEX,
      receivedHresh1xDetail: types.RECEIVED_HRESH1X_DETAIL
    })
  },
  components: {
    detail
  }
}
</script>




// WEBPACK FOOTER //
// component.vue?74704b49